import { render, staticRenderFns } from "./viewProductDetail.vue?vue&type=template&id=7b014762"
import script from "./viewProductDetail.vue?vue&type=script&lang=js"
export * from "./viewProductDetail.vue?vue&type=script&lang=js"
import style0 from "./viewProductDetail.vue?vue&type=style&index=0&id=7b014762&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports